import { useContext, useEffect, useState } from "react";
import { dateConvert, yearsOptions } from "../../../utils/Helper";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext";

export const useAwardYears = ({ filterValues, setFilterValues }) => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [loader, setLoader] = useState({ btn: false });
    const [createYear, setCreateYear] = useState({ visible: false });
    const [years, setYears] = useState([]);
    const createYearFields = [
        {
            label: "Year",
            name: "year_name",
            col: "12",
            type: "select",
            option: yearsOptions,
            required: true,
        },
        {
            label: "Ceremony Name",
            name: "ceremony_name",
            col: "12",
            type: "text",
            required: false,
        },
        {
            label: "Ceremony Date",
            name: "ceremony_date",
            col: "12",
            type: "date",
            dateFormat: "dd-mm-yy",
            required: false,
        },
    ]

    useEffect(() => {
        filterValues?.apiCall && getYears();
    }, [filterValues?.apiCall])

    const getYears = async () => {
        try {
            setLoader((prev) => ({ ...prev, data: true }));
            const res = await services.getInvokeRemote("POST", Urls("GETAWARDYEARS"), {});
            if (res?.body?.error_status === false) {
                const data = res?.body?.data?.award_years?.sort((a, b) => b?.year_name - a?.year_name);
                setYears(data);
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader((prev) => ({ ...prev, data: false }));
            setFilterValues((prev) => ({ ...prev, apiCall: false, categoryApiCall: true, nomineeApiCall: true }));
        }
    }

    const saveYear = async () => {
        try {
            if(!createYear?.year_name) {
                showInfo("Info", "Please select a year");
                return;
            }
            setLoader((prev) => ({ ...prev, btn: true }));
            const payload = {
                year_id: createYear?.year_id || 0,
                year_name: createYear?.year_name,
                ceremony_name: createYear?.ceremony_name,
                ceremony_date: dateConvert(createYear?.ceremony_date, "iso-string")?.split("T")?.[0] || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTAWARDYEARS"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("Success", res?.body?.message);
                setCreateYear({ visible: false });
                getYears();
            }
        } catch (error) {
            console.error("Error: ", error);
            error?.response?.data?.errorMessage && showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    const deleteYear = async () => {
        try {
            setLoader((prev) => ({ ...prev, delete: true }));
            const payload = {
                year_id: createYear?.delete?.year?.year_id || 0,
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETEAWARDYEARS"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("Success", res?.body?.message);
                setYears((prev) => prev?.filter(year => year?.year_id !== createYear?.delete?.year?.year_id));
                setCreateYear({visible: false});
            }
        } catch (error) {
            console.error("Error: ", error);
            error?.response?.data?.errorMessage && showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setLoader((prev) => ({ ...prev, delete: false }));
        }
    }

    const handleChange = (field, event) => {
        setCreateYear((prev) => ({ ...prev, [field?.name]: event?.target?.value }));
    }

    return { years, setYears, createYear, setCreateYear, createYearFields, handleChange, saveYear, loader, deleteYear }
}